import { gql } from '@apollo/client';

export const GET_BATCH_REPORT_DOWNLOAD_URLS_FOR_CS = gql`
  query CsReportQuery($reportIds: [Long!]!) {
    getBatchReportDownloadUrlsForCs(reportIds: $reportIds)
  }
`;

export interface GetBatchReportDownloadUrlsForCsResponse {
  getBatchReportDownloadUrlsForCs: string[];
}

export interface GetBatchReportDownloadUrlsVariables {
  reportIds: number[];
}
